/* @jsx h */
import { defineComponent, Fragment, ref, VNode, h } from "vue";

export type MasterDetailProps<T> = {
  items: T[];
  renderItem: (item: T, i: number, onEdit: Function) => VNode;
  renderEditView: (item: T, onClose: Function) => VNode;
  title: string;
};

export const MasterDetail = defineComponent<MasterDetailProps<unknown>>({
  name: "MasterDetailComponent",
  props: ["items", "renderItem", "renderEditView", "title"],
  setup(props) {
    const editingProduct = ref<unknown | null>(null);

    return () => {
      const { items } = props;
      return (
        <div class="flex-1 w-full overflow-hidden flex flex-col">
          <div class="p-4 border-b  flex justify-between items-center">
            <h2 class="text-2xl  text-white font-headline">{props.title}</h2>
            <button class="btn btn-primary">
              <span class="material-symbols-outlined">add</span>
            </button>
          </div>
          <div class="flex-1 overflow-y-auto p-4">
            <div class="space-y-4">
              {items.map((product, i) => {
                return (
                  <Fragment key={i}>
                    {props.renderItem(product, i, () => {
                      editingProduct.value = product;
                    })}
                  </Fragment>
                );
              })}
            </div>
          </div>

          {editingProduct.value &&
            props.renderEditView(
              editingProduct.value,
              () => (editingProduct.value = null),
            )}
        </div>
      );
    };
  },
});
